import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import { AUTHORIZATION_CODE_QUERY_PARAM } from '@wix/thunderbolt-symbols'
import type { MpaNavigationSiteConfig } from '../types'

const mpaNavigationSiteConfig: SiteConfigFn<MpaNavigationSiteConfig> = ({ api, funcLib }) => {
	const requestUrl = api.originalRequest.getUrl()
	const forceMpaNavigation =
		api.env.getExperiments()['specs.thunderbolt.forceMpaNavigation'] === true ||
		!!funcLib.getQueryParamValue(requestUrl, 'forceMpa')

	const isRunningInDifferentSiteContext = !!funcLib.getQueryParamValue(requestUrl, AUTHORIZATION_CODE_QUERY_PARAM)

	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: true,
		siteConfig: {
			forceMpaNavigation,
			isRunningInDifferentSiteContext,
		},
	}
}

const name = 'mpaNavigation'

export const config = { site: mpaNavigationSiteConfig, name }
